import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LoginComponent } from './login/login.component'
import { PasswordComponent } from './password/password.component'
import { ErrorMessageComponent } from './error-message/error-message.component'
import { UsersApiService } from './users-api.service'
import { RedirectService } from './redirect.service'
import { EnvironmentService } from './environment.service'
import { WindowService } from './window.service'
import { CookieService } from 'ngx-cookie-service'
import { SignupComponent } from './signup/signup.component'
import { DropOffComponent } from './drop-off/drop-off.component'
import { LoggedInGuardService } from './logged-in-guard.service'

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PasswordComponent,
    ErrorMessageComponent,
    SignupComponent,
    DropOffComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [
    WindowService,
    CookieService,
    UsersApiService,
    EnvironmentService,
    RedirectService,
    LoggedInGuardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
